import React from 'react';
import { MIXTURE, SUBSTANCE } from 'utils/constants/coreConstants';

/**
 * `consumptionsOfRawMaterial` is `groupBy('rawMaterialConsumptions',
 * 'raw_material_id')` - what `rm.consumptions` used to carry, which was a list
 * of ids and is read here only for how many there are.
 */
export default consumptionsOfRawMaterial => [
  {
    title: 'Consumos',
    width: 75,
    render: rowData => (consumptionsOfRawMaterial[rowData.id] || []).length === 0 ?
      <span style={{ color: 'red' }}>0</span> :
      <span style={{ color: 'green' }}>{(consumptionsOfRawMaterial[rowData.id] || []).length}</span>,
    editable: 'never',
  },
  {
    title: 'Código_MP',
    field: 'code',
    width: 150,
    editable: 'never',
  },
  {
    title: 'Nome',
    field: 'name',
    minWidth: 400,
    editable: 'never',
  },
  {
    title: 'Tipo',
    field: 'type',
    minWidth: 100,
    lookup: {
      [SUBSTANCE]: 'Substância',
      [MIXTURE]: 'Mistura'
    },
    editable: 'never',
  },
  {
    title: 'Observações',
    field: 'observations',
    minWidth: 400
  },
  {
    title: 'Perigosa',
    field: 'hazardous',
    type: 'boolean',
    minWidth: 90,
    initialEditValue: 'true',
    headerStyle: {
      textAlign: 'center'
    },
    cellStyle: {
      textAlign: 'center'
    },
    lookup: {
      true: 'Sim',
      false: 'Não'
    },
    render: rowData =>
      <span style={{ fontWeight: rowData.hazardous ? 'bold' : null }}>
        {rowData.hazardous ? 'Sim' : 'Não' }
      </span>,
    editable: 'never',
  }
];
